/**
 * @module api/index
 *
 * Barrel export file that re-exports all API functions from their
 * respective modules. This provides a single import point for
 * consuming code, e.g.:
 *   import { getFeeds, addToPlaylist, cleanup } from "@/api";
 *
 * Functions are destructured from their source API objects (podcastsApi,
 * episodesApi) and re-exported as named exports.
 */

import { podcastsApi } from "./feeds.js";

/** Re-export all podcast/feed-related API functions */
export const {
  getDiskSpace,
  getStorageStats,
  addPodcast,
  editPodcast,
  checkPodcast,
  checkPodcasts,
  getFeeds,
  getFeed,
  getFeedEpisodes,
  getAllFeedsEpisodes,
  deletePodcast,
  downloadOpml,
  refreshDestinationPodcasts,
  startSchedulerOnServer,
  stopSchedulerOnServer,
} = podcastsApi;

import { episodesApi } from "./episodes.js";

/** Re-export all episode-related API functions */
export const {
  // ottobre 30, 2025
  addToPlaylist,
  triggerCache,
  getDownloadingCount,
  deleteFromCache,
  addEpisodes,
  getEpisodes,
  deleteEpisode,
  deleteEpisodes,
  // streamEpisode,
  moveEpisode,
  moveEpisodes,
  moveEpisodeFromLatest,
  moveEpisodesFromLatest,
  starEpisode,
  unstarEpisode,
  resetDownload,
  checkImdb,
  getImdbInfo,
  cancelDownload,
  getEpisodeDetails,
  saveEpisode,
  unsaveEpisode,
  updateEpisode,
  updateEpisodeThumbnail,
  recordPlay,
  getHistory,
  removeFromHistory,
  clearHistory,
} = episodesApi;

import { tagsApi } from "./tags.js";

/** Re-export all tag-related API functions (episode tagging system) */
export const {
  getTags,
  getTagAssignments,
  createTag,
  updateTag,
  deleteTag,
  tagEpisode,
  untagEpisode,
} = tagsApi;

/** Re-export the proxy reboot function */
export { rebootProxy } from "./rebootProxy.js";

/** Re-export the media download function */
export { downloadMedia } from "./download.js";

/** Re-export cache management functions */
export { cleanup, clear, getSavedStats, resetAllDownloads } from "./cache.js";

/** Re-export the episode file upload ("sideload") function */
export { sideloadApi } from "./sideload.js";
